import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm, SubmitHandler } from 'react-hook-form';
import { Box, Container, Snackbar } from '@mui/material';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { createMentor } from 'apis';
import { useAuth } from 'app/ProviderAuth';
import { Button } from 'components';
import { MentorForm } from './components/MentorForm';
import { Mentor } from 'types';
import { defaultWeeklySchedule } from 'helper/time';

// Extend dayjs with timezone support
dayjs.extend(utc);
dayjs.extend(timezone);

export const SignUpMentorPage: React.FC = () => {
  const navigate = useNavigate();
  const { user, isMentor, setIsMentor } = useAuth();
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const {
    control,
    handleSubmit,
    formState: { isSubmitting, errors },
  } = useForm<Mentor>({
    defaultValues: {
      name: '',
      email: user?.email ?? '',
      pictureUrl: '',
      profileBio: '',
      title: '',
      bookingLink: '',
      tags: [],
      availableTime: defaultWeeklySchedule,
      timezone: dayjs.tz.guess(), // Auto-detect user's timezone
      countryCode: '',
      uid: user?.uid ?? '',
      isActivated: true,
    },
    mode: 'onBlur',
  });
  useEffect(() => {
    if (!user) {
      navigate('/signup');
    }
    if (isMentor) {
      navigate('/edit/profile?profileType=mentor');
    }
  }, [user, navigate, isMentor]);
  const onSubmit: SubmitHandler<any> = async (data) => {
    if (!user) {
      return;
    }
    data.tags = Array.isArray(data.tags) ? data.tags : data.tags.split(',').map((tag:string) => tag.trim());
    const mentorData: Mentor = data as Mentor;
    mentorData.name = mentorData.name.trim();
    mentorData.title = mentorData.title!.trim();
    mentorData.email = mentorData.email.trim();
    mentorData.isActivated = true;
    await createMentor(user.uid, mentorData);
    setSnackBarOpen(true);
    setIsMentor(true);
  };

  const backToDoor = () => {
    navigate('/door');
  };
  return (
    <Box my={5}>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={snackBarOpen}
        message="成功成為導師"
        action={
          <Button color="secondary" onClick={backToDoor}>
            回首頁
          </Button>
        }
      />
      <Container maxWidth="md" sx={{ my: 4 }}>
        <MentorForm
          control={control}
          errors={errors}
          handleSubmit={handleSubmit(onSubmit)}
          isSubmitting={isSubmitting}
          submitted={snackBarOpen}
        />
      </Container>
    </Box>
  );
};
